<template>
  <div class="text-center relative">
    <aha-icon name="no-result" maintain-color />
    <div class="pt-4 font-bold text-base">
      {{ $i18nPresenter.t("We couldn't find any results matching") }} {{ getSearchContent }}
    </div>
    <tool-box
      class="flex justify-center mt-4"
      :isHideNewFolder="true"
      :isHideSortBy="true"
      :isFromSearchingNoData="true"
    />
  </div>
</template>
<script>
import ToolBox from '@/components-v2/my-presentations/ToolBox.vue'

export default {
  components: {
    ToolBox,
  },
  computed: {
    getSearchContent() {
      if (this.$route.query.q && this.$route.query.q.length > 1) {
        return `"${this.$route.query.q}".`
      }
      return 'this search.'
    },
  },
}
</script>
